import "../main.js";
import Alpine from "../plugins/alpine";

Alpine.start();
